export default {
  BUDG_FOR_YEAR: 'תקציב המדינה לשנת',
  HE: 'הוא',
};



// WEBPACK FOOTER //
// ./app/scripts/Hasadna/oBudget/l10n/he-IL.js